import React from 'react';
import styles from './index.module.scss';
import cn from 'classnames';

type Props = { 
    className?: string;
    width?: number;
    height?: number;    
};

export const IconArrowRight: React.FC<Props> = ({
    className,
    width = 20,
    height = 20,
}) => (
    <span 
        className={cn('apc-svg-icon', styles.iconArrowRight, className)} 
        style={{width:`${width}px`, height:`${height}px`}}
    />
);
